// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__TcGK+","fadeIn":"footer_fadeIn__BHYQQ","icon":"footer_icon__Zxz2c","theIcon":"footer_theIcon__tYkMe"};